import { IShopItem } from '~/src/api/content/shop/getShopItems';
import PartnerCard from '~/src/features/domru-bonus/components/PartnerCard';

import { BonusCarousel } from '~/src/features/domru-bonus/components/Carusel/styled';

const breakpoints = [
    { width: 0, slidesToShow: 1 },
    { width: 680, slidesToShow: 2 },
    { width: 1024, slidesToShow: 3 },
    { width: 1599, slidesToShow: 4 },
];

interface IProps {
    partners: IShopItem[],
}

const Partners = ({ partners }: IProps):JSX.Element => {
    return (
        <BonusCarousel
            visibleCardWidth={1920}
            responsive={breakpoints}
            showArrows={false}
            showDots={false}
            showTransparent={true}
            hideArrow={true}
        >
            {partners.map((partner) => {
                const { id, title, body, image, advertising } = partner;
                return (
                    <PartnerCard
                        key={id}
                        title={title}
                        body={body}
                        image={image || ''}
                        advertiserName={advertising?.companyName || ''}
                        advertiserErid={advertising?.erid || ''}
                    />
                );
            })}
        </BonusCarousel>
    );
};

export default Partners;
